import React from "react";
import { useTranslation } from "react-i18next";
import {
    Divider,
    Text,
    useColorModeValue,
    Box
} from "@chakra-ui/react";
import { LOCALE_PT_BR } from "constants/date-time";
import TimelineRow from "components/Tables/TimelineRow";
import { FaIdCard, FaUserEdit, FaUserPlus } from "react-icons/fa";
import { BsPersonBadge } from 'react-icons/bs';
import { isDifferentValue, toTitleCase } from "utils/utils";

function AgentTimeline({ creationDate, historyData }) {
    const { t } = useTranslation();
    const textColor = useColorModeValue("gray.700", "white");

    const iconMap = {
        codigo: BsPersonBadge,
        nome: FaUserEdit,
        cpf_cnpj: FaIdCard
    };

    const getChangeMessage = (key, oldValue, newValue) => {
        const basePath = 'settings.agent.details.tab-timeline';

        if (key === "codigo") {
            return t(`${basePath}.changes.registration`, { oldValue, newValue });
        }

        if (key === "cpf_cnpj") {
            return t(`${basePath}.changes.cpf-cnpj`, { oldValue, newValue });
        }

        return t(`${basePath}.changes.generic-change`, {
            key: toTitleCase(key),
            oldValue,
            newValue
        });
    };

    const timelineData = [
        ...(creationDate
            ? [{
                key: "creation",
                title: t("settings.agent.details.tab-timeline.changes.data-creation"),
                date: creationDate,
                logo: FaUserPlus
            }]
            : []),

        ...historyData.map((entry, i) => {
            let icon = null;
            const messages = [];

            Object.entries(entry.dados_antigos).forEach(([key, oldValue]) => {
                const newValue = entry.dados_novos[key];

                if (isDifferentValue(oldValue, newValue)) {
                    if (!icon && iconMap[key]) {
                        icon = iconMap[key];
                    }

                    const msg = getChangeMessage(key, oldValue, newValue);
                    if (Array.isArray(msg)) {
                        messages.push(...msg);
                    } else {
                        messages.push(msg);
                    }
                }
            });

            return {
                key: `history-${i}`,
                title: messages.join(". "),
                date: new Date(entry.data).toLocaleString(LOCALE_PT_BR),
                logo: icon
            };
        })
    ];

    return (
        <>
            <Text fontSize="md" fontWeight="bold" color={textColor}>
                {t("settings.agent.details.tab-timeline.title")}
            </Text>
             <Divider borderColor="#3884cc" />
            <Box m="4">
                {timelineData.map((entry, index) => (
                    <TimelineRow
                        key={entry.key}
                        title={entry.title}
                        titleColor={textColor}
                        date={entry.date}
                        color={textColor}
                        logo={entry.logo}
                        index={index}
                        arrLength={timelineData.length}
                    />
                ))}
            </Box>
        </>
    );
}

export default AgentTimeline;